import i18n from "../../../../../../constants/i18n";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import { TalkhattabatConversationType } from "../../../../../../Types";
import Et3Image from "../../../../../../core/et3-Image";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";

const UploadImage = withLiteObserverAndTheme<{
  alkhattabaUUID: string;
  userUUID: string;
  userID: number;
  conversationID: string;
  peerID: number;
  peerUUID: string;
  conversationType: TalkhattabatConversationType;
  oneOTwoConversationId: string;
  oneOOneCId: string
}>((props) => {
  const {
    alkhattabaUUID,
    userUUID,
    conversationType,
    userID,
    conversationID,
    peerID,
    peerUUID,
    oneOTwoConversationId,
    oneOOneCId
  } = props;

  const shouldShow = !getCorePersonalStore().isKhattabaAiAdmin.get()

  return !shouldShow ? null : (
    <ET3Div
      width={30}
      height={40}
      alignItems={"center"}
      fDirection={"column"}
      justifyContent={"center"}
      style={{}}
      color={""}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={async () => {
        const commonParams = {
          alkhattabaUUID,
          userUUID,
          conversationID,
          conversationType,
          peerID,
          peerUUID,
          oneOTwoConversationId
        };

        switch (conversationType) {
          default:
          case "101C":
            return getKhattabatStore().handleImageUpload({
              ...commonParams,
              userID,
              oneOOneCId
            });
          case "101C_COMMENTS":
            return getKhattabatStore().handleImageUpload({
              ...commonParams,
              userID: peerID,
              oneOOneCId
            });
          case "101M":
            return getKhattabatStore().handleImageUpload({
              ...commonParams,
              userUUID: peerUUID,
              userID: peerID,
              oneOOneCId
            });
          case "101M_COMMENTS":
            return getKhattabatStore().handleImageUpload({
              ...commonParams,
              userUUID: peerUUID,
              userID: peerID,
              oneOOneCId
            });
        }
      }}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER")}
        imageName={"khattabat-image-logo"}
        size={25}
        onClick={() => { }}
        style={{ cursor: "pointer" }}
      />
    </ET3Div>
  );
});

export default UploadImage;
